import { useEffect } from "react"
import useTrackingParams from "../../helpers/hooks/use-tracking-params"

export const UtmTracker = () => {
  const trackingParams = useTrackingParams()
  useEffect(() => {
    if (trackingParams && Object.values(trackingParams).some((v) => v)) {
      localStorage.setItem("trackingParams", JSON.stringify(trackingParams))
    }
  }, [trackingParams])
  return null
}